<template>
    <div>
        <b-form>
            <b-col cols="12" class="d-flex justify-content-end">
                <b-button variant="primary" @click="adicionarItem">
                    +
                </b-button>
            </b-col>

            <b-table responsive class="mt-2" small :items="contratoForm.orgaosContratos" :fields="fields" hover>
                <template v-slot:cell(departamento)="data">
                    <LgFinderPageUnidadeAdministrativa :prefix="prefix" label=" "
                        @onselect="function (departamento) { setDepartamento(data.item, departamento) }"
                        v-model="data.item.departamento" v-if="data.item.tipoOrgao && data.item.tipoOrgao.id"
                        :isOrnograma="data.item.tipoOrgao.id == 2" />
                </template>
                <template v-slot:cell(tipoOrgao)="data">
                    <LgFinderPageTipoOrgao @input="function (tipo) { setTipoOrgao(data.item, tipo) }"
                        :id="'finderTipoOrgaoContratosForm' + data.index" label=" " v-model="data.item.tipoOrgao"
                        invalidFeedback=" " :title="'Tipo Orgão'" :prefix="prefix" />

                </template>

                <template v-slot:cell(acoes)="data">
                    <b-button v-if="!isEditMode" size="sm" pill variant="danger" @click="removerOrgaoContrato(data.item)">
                        <b-icon icon="trash" />
                    </b-button>
                </template>
            </b-table>
        </b-form>
    </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import LgFinderPageTipoOrgao from "@/components/Finders/LgFinderPageTipoOrgao.vue";
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue";

export default {
    name: "OrgaosContratosForm",
    mixins: [validationMixin],
    components: {
        LgFinderPageTipoOrgao,
        LgFinderPageUnidadeAdministrativa,
    },
    props: {
        prefix: {
            type: String,
            default: ""
        },

        contratoFormProp: {
            type: Object,
            required: true,
        },
        isEditMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {

            contratoForm: this.contratoFormProp,
            fields: [
                { key: "tipoOrgao", label: "Tipo Orgão" },

                { key: "departamento", label: "Departamento" },
                { key: "acoes", label: "Ações", class: "text-center" },
            ],
        };
    },
    methods: {
        setDepartamento(item, departamento) {
            item.departamento = departamento;
        },
        setTipoOrgao(item, tipo) {
            item.tipoOrgao = tipo;
        },
        adicionarItem() {
            this.contratoForm.orgaosContratos.push({  tipoOrgao: {}, departamento: {} })
        },
        removerOrgaoContrato(index) {
            this.contratoForm.orgaosContratos.splice(index, 1);
        },

    },
};
</script>

<style scoped>
.mt-2 {
    margin-top: 0.5rem;
}

.ml-2 {
    margin-left: 0.5rem;
}

.mt-3 {
    margin-top: 1rem;
}
</style>
